import React, { Component } from 'react';
import PropTypes, { checkPropTypes } from 'prop-types';

import authService, { AuthenticationResultStatus } from './AuthorizeService';

import { LogoutActions } from './AuthorizationConstants';

// The main responsibility of this component is to handle the user's logout process.
// This is the starting point for the logout process, which is usually initiated when a
// user clicks on the logout button on the LoginMenu component.
export default class Logout extends Component {
  constructor(props) {
    super(props);
    checkPropTypes(Logout.propTypes, props, 'prop', Logout.name);
    this.state = {
      message: undefined,
      isReady: false
    };
  }

  componentDidMount() {
    const { action } = this.props;
    switch (action) {
      case LogoutActions.Logout:
        this.logout();
        break;
      case LogoutActions.LoggedOut:
        this.setState({ isReady: true, message: 'You successfully logged out!' });
        break;
      default:
        throw new Error(`Invalid action '${action}'`);
    }
  }

  async logout() {
    const isauthenticated = await authService.isAuthenticated();
    if (isauthenticated) {
      const result = await authService.signOut();
      switch (result.status) {
        case AuthenticationResultStatus.Redirect:
          break;
        case AuthenticationResultStatus.Fail:
          this.setState({ message: result.message });
          break;
        default:
          throw new Error('Invalid authentication result status.');
      }
    } else {
      this.setState({ message: 'You successfully logged out!' });
    }
  }

  render() {
    const { isReady, message } = this.state;
    if (!isReady) {
      return <div />;
    }
    if (message) {
      return <div>{message}</div>;
    }
    const { action } = this.props;
    switch (action) {
      case LogoutActions.Logout:
        return <div>Processing logout</div>;
      case LogoutActions.LoggedOut:
        return <div>{message}</div>;
      default:
        throw new Error(`Invalid action '${action}'`);
    }
  }
}

Logout.propTypes = {
  action: PropTypes.string.isRequired
};
